/**
 * `/lists` — the lists management surface.
 *
 * One `RouteObject`, so the file is `lists-index.route.tsx` (singular); the
 * area's aggregate array is `lists.routes.tsx` (plural), and the importer
 * knows the shape from the name.
 *
 * The route resolves nothing and fetches nothing: **no `loader` in this repo
 * performs a data read.** A fetching loader would create a cache TanStack
 * Query does not know about, and the two would drift on every mutation. The
 * page component owns its reads.
 *
 * The chunk is split through the router's OWN `lazy` — the data router awaits
 * it before it renders the match, so the feature needs no `Suspense` boundary
 * of its own.
 */
import type { RouteObject } from 'react-router-dom';

export const listsIndexRoute: RouteObject = {
  path: 'lists',
  lazy: async () => {
    const { ListsIndexPage } = await import('./ListsIndexPage');
    return { Component: ListsIndexPage };
  },
};
